import { Bell, type LucideIcon, Swords } from 'lucide-react';

export type NotificationTypeConfig = {
  icon: LucideIcon;
  iconColorClass: string;
  fallbackTitle: string;
};

const DEFAULT_CONFIG: NotificationTypeConfig = {
  icon: Bell,
  iconColorClass: 'text-muted-foreground',
  fallbackTitle: 'Notification',
};

export const NOTIFICATION_TYPE_CONFIG: Record<string, NotificationTypeConfig> = {
  duel_created: {
    icon: Swords,
    iconColorClass: 'text-primary',
    fallbackTitle: 'Duel',
  },
};

export function getNotificationTypeConfig(typeId: string): NotificationTypeConfig {
  return NOTIFICATION_TYPE_CONFIG[typeId] ?? DEFAULT_CONFIG;
}
